module.exports = __webpack_public_path__ + "static/scale-model-of-odessa-texas-cb13e53d11232f33715f8d25be078341.png";